export default {
  mounted() {
    this.setBg("unset");
  },
  methods: {
    setBg(bgStyle) {
      const contentBox = document.querySelector(".content_bg");
      contentBox.style.backgroundColor = bgStyle;
    }
  },
  beforeDestroy() {
    this.setBg("");
  }
};
